import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ElevatedButton } from '@producer/ui-kit';

import { useCurrentProject } from '../../hooks/use-current-project';
import { Header } from './project.page';
import { LocationList } from '../../features/locations/components/location-list';
import { CreateLocationDrawer } from '../../features/locations/components/create-location.drawer';
import { uiStore } from '../../core/stores/ui-store';

import styles from './project-locations.route.module.scss';
export const ProjectLocationsRoute = observer(() => {
  const project = useCurrentProject()!;
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    uiStore.currentLocation = 'project.locations';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <>
      <Header>
        <div>Locations</div>

        <ElevatedButton text="Create location" onClick={() => setIsCreateModalOpen(true)} />
      </Header>

      <div className={styles['content']}>
        <div className={styles['container']}>
          <LocationList
            locations={project.locations}
            onOpenModal={() => setIsCreateModalOpen(true)}
          />
        </div>

        {isCreateModalOpen && <CreateLocationDrawer onCancel={() => setIsCreateModalOpen(false)} />}
      </div>
    </>
  );
});
